import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddOverlayComponent } from './add-overlay.component';
import AddOverlayService from './add-overlay.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {NoteModule} from '../note/note.module';
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";



@NgModule({
    declarations: [AddOverlayComponent],
    exports: [
        AddOverlayComponent
    ],
    imports: [
        CommonModule,
        NoteModule,
        MatSnackBarModule,
        FormsModule,
        RouterModule
    ],
  providers: [
    AddOverlayService
  ]
})
export class AddOverlayModule { }
